export class EmailValidator {
    private static readonly emailRegex: RegExp = /^([a-z0-9_+%=-][.a-z0-9_+%=-]{0,63})@(([a-z0-9]([a-z0-9-]*[a-z0-9])?[.])+([a-z]{2,30}|xn--[a-z0-9-]{2,30}))$/i;
    static validate(email: string): boolean {
        return this.emailRegex.test(email);
    }
}
